export default __webpack_public_path__ + "static/media/Roboto-Bold.bbb913f0.woff";